/**
 * @packageDocumentation
 * @module api.functional.admin.users
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { CreateUserDto } from "../../../structures/CreateUserDto";
import type { PaginationQuery } from "../../../structures/PaginationQuery";
import type { ServiceResponse__object } from "../../../structures/ServiceResponse__object";
import type { ServiceResponseGetUserDto } from "../../../structures/ServiceResponseGetUserDto";
import type { ServiceResponsenull } from "../../../structures/ServiceResponsenull";
import type { ServiceResponsePageOfGetUserDto } from "../../../structures/ServiceResponsePageOfGetUserDto";
import type { ServiceResponsevoid } from "../../../structures/ServiceResponsevoid";
import type { UpdateUserDto } from "../../../structures/UpdateUserDto";

export * as settings from "./settings/index";
export * as promote from "./promote/index";
export * as invite from "./invite/index";
export * as alerts from "./alerts/index";

/**
 * @controller UserController.getUsers
 * @path GET /admin/users
 * @accessor api.functional.admin.users.getUsers
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getUsers(
  connection: IConnection,
  paginationParams: getUsers.Query,
): Promise<getUsers.Output> {
  return PlainFetcher.fetch(connection, {
    ...getUsers.METADATA,
    template: getUsers.METADATA.path,
    path: getUsers.path(paginationParams),
  });
}
export namespace getUsers {
  export type Query = PaginationQuery;
  export type Output = ServiceResponsePageOfGetUserDto;

  export const METADATA = {
    method: "GET",
    path: "/admin/users",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (paginationParams: Query) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(paginationParams as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/admin/users";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}

/**
 * @controller UserController.createUser
 * @path POST /admin/users
 * @accessor api.functional.admin.users.createUser
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function createUser(
  connection: IConnection,
  body: createUser.Body,
): Promise<createUser.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...createUser.METADATA,
      template: createUser.METADATA.path,
      path: createUser.path(),
    },
    body,
  );
}
export namespace createUser {
  export type Body = CreateUserDto;
  export type Output = ServiceResponseGetUserDto;

  export const METADATA = {
    method: "POST",
    path: "/admin/users",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = () => "/admin/users";
}

/**
 * @controller UserController.updateUser
 * @path PATCH /admin/users/:id
 * @accessor api.functional.admin.users.updateUser
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function updateUser(
  connection: IConnection,
  id: string,
  body: updateUser.Body,
): Promise<updateUser.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...updateUser.METADATA,
      template: updateUser.METADATA.path,
      path: updateUser.path(id),
    },
    body,
  );
}
export namespace updateUser {
  export type Body = UpdateUserDto;
  export type Output = ServiceResponseGetUserDto;

  export const METADATA = {
    method: "PATCH",
    path: "/admin/users/:id",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (id: string) =>
    `/admin/users/${encodeURIComponent(id?.toString() ?? "null")}`;
}

/**
 * @controller UserController.deleteUser
 * @path DELETE /admin/users/:id
 * @accessor api.functional.admin.users.deleteUser
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function deleteUser(
  connection: IConnection,
  id: string,
): Promise<deleteUser.Output> {
  return PlainFetcher.fetch(connection, {
    ...deleteUser.METADATA,
    template: deleteUser.METADATA.path,
    path: deleteUser.path(id),
  });
}
export namespace deleteUser {
  export type Output =
    | ServiceResponsevoid
    | ServiceResponse__object
    | ServiceResponsenull;

  export const METADATA = {
    method: "DELETE",
    path: "/admin/users/:id",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (id: string) =>
    `/admin/users/${encodeURIComponent(id?.toString() ?? "null")}`;
}
